import React from "react";

const Loader = () => {
    return (
        <div
            className="d-flex justify-content-center align-items-center"
            style={{
                height: "100vh",
                backgroundColor: "#f8f9fa",
            }}
        >
            <div className="text-center">
                <div className="spinner-border text-primary" role="status" style={{ width: "5rem", height: "5rem" }}>
                    <span className="visually-hidden">Chargement...</span>
                </div>
                <h5 className="mt-3 text-muted">Chargement en cours...</h5>
            </div>
        </div>
    );
};

export default Loader;
